module.exports = __webpack_public_path__ + "assets/threat.4adb4957.svg";